import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b2f7332"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Header-item flex-items-center" }
const _hoisted_2 = { class: "Header-item width-full" }
const _hoisted_3 = ["placeholder", "value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Header-item Header-item--full" }, null, -1))
const _hoisted_5 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  "aria-label": "Activate dark mode",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.598 1.591a.75.75 0 01.785-.175 7 7 0 11-8.967 8.967.75.75 0 01.961-.96 5.5 5.5 0 007.046-7.046.75.75 0 01.175-.786zm1.616 1.945a7 7 0 01-7.678 7.678 5.5 5.5 0 107.678-7.678z"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  "aria-label": "Activate light mode",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM8 12a4 4 0 100-8 4 4 0 000 8zM8 0a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0V.75A.75.75 0 018 0zm0 13a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5A.75.75 0 018 13zM2.343 2.343a.75.75 0 011.061 0l1.06 1.061a.75.75 0 01-1.06 1.06l-1.06-1.06a.75.75 0 010-1.06zm9.193 9.193a.75.75 0 011.06 0l1.061 1.06a.75.75 0 01-1.06 1.061l-1.061-1.06a.75.75 0 010-1.061zM16 8a.75.75 0 01-.75.75h-1.5a.75.75 0 010-1.5h1.5A.75.75 0 0116 8zM3 8a.75.75 0 01-.75.75H.75a.75.75 0 010-1.5h1.5A.75.75 0 013 8zm10.657-5.657a.75.75 0 010 1.061l-1.061 1.06a.75.75 0 11-1.06-1.06l1.06-1.06a.75.75 0 011.06 0zm-9.193 9.193a.75.75 0 010 1.06l-1.06 1.061a.75.75 0 11-1.061-1.06l1.06-1.061a.75.75 0 011.061 0z"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Header-item flex-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://material.io/develop/web/getting-started",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "Header-link mr-3"
  }, " Get Started ")
], -1))
const _hoisted_12 = { class: "position-sticky top-0 d-flex flex-items-center flex-nowrap border-bottom py-2 color-bg-default" }
const _hoisted_13 = {
  class: "BtnGroup",
  "aria-label": "Icon type"
}
const _hoisted_14 = ["aria-selected", "onClick"]
const _hoisted_15 = {
  key: 0,
  class: "octicon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Ellipse", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z" }, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "octicon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Triangle", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "32",
  d: "M48 448L256 64l208 384H48z"
}, null, -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 2,
  class: "octicon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Square", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M416 448H96a32.09 32.09 0 01-32-32V96a32.09 32.09 0 0132-32h320a32.09 32.09 0 0132 32v320a32.09 32.09 0 01-32 32z",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "32"
}, null, -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "hide-sm" }
const _hoisted_28 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  style: {"vertical-align":"text-bottom"},
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.679 7.932c.412-.621 1.242-1.75 2.366-2.717C5.175 4.242 6.527 3.5 8 3.5c1.473 0 2.824.742 3.955 1.715 1.124.967 1.954 2.096 2.366 2.717a.119.119 0 010 .136c-.412.621-1.242 1.75-2.366 2.717C10.825 11.758 9.473 12.5 8 12.5c-1.473 0-2.824-.742-3.955-1.715C2.92 9.818 2.09 8.69 1.679 8.068a.119.119 0 010-.136zM8 2c-1.981 0-3.67.992-4.933 2.078C1.797 5.169.88 6.423.43 7.1a1.619 1.619 0 000 1.798c.45.678 1.367 1.932 2.637 3.024C4.329 13.008 6.019 14 8 14c1.981 0 3.67-.992 4.933-2.078 1.27-1.091 2.187-2.345 2.637-3.023a1.619 1.619 0 000-1.798c-.45-.678-1.367-1.932-2.637-3.023C11.671 2.992 9.981 2 8 2zm0 8a2 2 0 100-4 2 2 0 000 4z"
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  style: {"vertical-align":"text-bottom"},
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M.143 2.31a.75.75 0 011.047-.167l14.5 10.5a.75.75 0 11-.88 1.214l-2.248-1.628C11.346 13.19 9.792 14 8 14c-1.981 0-3.67-.992-4.933-2.078C1.797 10.832.88 9.577.43 8.9a1.618 1.618 0 010-1.797c.353-.533.995-1.42 1.868-2.305L.31 3.357A.75.75 0 01.143 2.31zm3.386 3.378a14.21 14.21 0 00-1.85 2.244.12.12 0 00-.022.068c0 .021.006.045.022.068.412.621 1.242 1.75 2.366 2.717C5.175 11.758 6.527 12.5 8 12.5c1.195 0 2.31-.488 3.29-1.191L9.063 9.695A2 2 0 016.058 7.52l-2.53-1.832zM8 3.5c-.516 0-1.017.09-1.499.251a.75.75 0 11-.473-1.423A6.23 6.23 0 018 2c1.981 0 3.67.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.619 1.619 0 010 1.798c-.11.166-.248.365-.41.587a.75.75 0 11-1.21-.887c.148-.201.272-.382.371-.53a.119.119 0 000-.137c-.412-.621-1.242-1.75-2.366-2.717C10.825 4.242 9.473 3.5 8 3.5z"
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "popularity" }, "Popularity", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "name" }, "Name", -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-3 my-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Loading"),
  /*#__PURE__*/_createElementVNode("span", { class: "AnimatedEllipsis" })
], -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "grid my-3" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "d-flex flex-column" }
const _hoisted_44 = { class: "grid-item-icon d-flex flex-justify-center" }
const _hoisted_45 = { class: "grid-item-title d-flex flex-justify-center" }
const _hoisted_46 = { class: "grid-item-description d-flex flex-justify-center" }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blankslate blankslate-spacious" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-2" }, "Can’t find any icons."),
  /*#__PURE__*/_createElementVNode("p", null, "Clear your filters and try again.")
], -1))
const _hoisted_49 = [
  _hoisted_48
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Details = _resolveComponent("Details")!
  const _directive_observe_visibility = _resolveDirective("observe-visibility")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("header", {
      class: "Header",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Logo, { classname: "ml-1" })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          class: "form-control input-sm header-search width-full",
          type: "search",
          spellcheck: "false",
          "aria-label": "Icon search",
          ref: "searchRef",
          placeholder: _ctx.placeholder,
          value: _ctx.searchText,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:searchText', $event.target.value)))
        }, null, 40, _hoisted_3)
      ]),
      _hoisted_4,
      _createElementVNode("div", {
        class: "Header-item flex-items-center theme-icon",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeColorMode(_ctx.colorMode === 'light' ? 'dark' : 'light')))
      }, [
        (_ctx.colorMode === 'light')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
      ]),
      _hoisted_11
    ])), [
      [_directive_observe_visibility, _ctx.visibilityChanged]
    ]),
    _createElementVNode("main", {
      class: "details-reset details-overlay details-overlay-dark mb-4 width-full",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codePoints, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item.font,
              "aria-selected": item.font == _ctx.font ? 'true': 'false',
              onClick: ($event: any) => (_ctx.onChangeFont(item.font)),
              class: "BtnGroup-item btn",
              type: "button"
            }, [
              (item.font === 'round')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_18))
                : (item.font === 'sharp')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_22))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_26)),
              _createElementVNode("span", _hoisted_27, _toDisplayString(item.label), 1)
            ], 8, _hoisted_14))
          }), 128))
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn",
            type: "button",
            "aria-label": "toggle show codepoint",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleShowCodepoint && _ctx.toggleShowCodepoint(...args)))
          }, [
            (_ctx.showCodepoint)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30))
              : (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_33))
          ])
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "aria-label": "Sort",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sort) = $event))
        }, _hoisted_36, 512), [
          [_vModelSelect, _ctx.sort]
        ])
      ]),
      (_ctx.icons.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
        : (_ctx.filteredIcons.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredIcons, (icon, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["grid-item", { active: icon.name === _ctx.selectedName }]),
                    key: index,
                    onClick: ($event: any) => (_ctx.select(icon.name))
                  }, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("span", {
                          class: _normalizeClass([`icon ${_ctx.font === 'filled' ? 'material-icons' : `material-icons-${_ctx.font}`}`])
                        }, _toDisplayString(icon.name), 3)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("span", {
                          class: "text-small css-truncate css-truncate-overflow pl-1 pr-1",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                        }, _toDisplayString(icon.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _withDirectives(_createElementVNode("span", {
                          class: "text-small css-truncate css-truncate-overflow pl-1 pr-1",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                        }, _toDisplayString(icon.codepoint), 513), [
                          [_vShow, _ctx.showCodepoint]
                        ])
                      ])
                    ])
                  ], 10, _hoisted_42))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_49)),
      (!!_ctx.selectedName)
        ? (_openBlock(), _createBlock(_component_Details, _normalizeProps(_mergeProps({ key: 3 }, _ctx.selectedIcon)), null, 16))
        : _createCommentVNode("", true)
    ])
  ], 64))
}